export default {
  privacyCenter: {
    header: {
      feature: "Live Preview",
      heading: "Privacy Center",
      description: "Use the options below to customise your Privacy Center",
    },
    tabs: {
      theme: "Theme",
      language: "Language",
      preview: "Preview",
      websiteInstallation: "Website Installation",
    },
    language: {
      header: {
        feature: "Language",
        heading: "Privacy Center Languages",
        description:
          "Use the options below to update the languages your Privacy Center will display in",
      },
      title: "Update Active Languages",
      description:
        "If you would like to show your Privacy Center and policies in different languages, add them by selecting them in the card below.  <1>Please be aware that you will need to provide the policies in the selected languages - Dataships does not provide translation services</1>",
      selectLabel: "Language",
      cta: "Save",
      toastSuccess: "Successfully updated your active languages",
    },
    theme: {
      header: {
        feature: "Theme",
        heading: "Theme",
        description:
          "Please see below options to customize your Privacy Center.",
      },
      form: {
        primaryColour: "Text color",
        secondaryColour: "Background color",
        ctaColour: "CTA color",
        font: "Font",
        saveButton: "Save",
        privacyEmail: "Privacy Email",
        errors: {
          colourRequired: "Select Color",
          colourCode: "Color must start with #",
          colourLength: "Color must be 4 or 7 chars",
          fontRequired: "Select Font",
          imageFileSize: "Uploaded file is too big",
          imageFileFormat: "Uploaded file has unsupported format",
          emailRequired: "You must supply an email address.",
          emailInvalid: "Please provide a valid email address.",
        },
      },
      section: {
        brand: {
          title: "Edit your brand colors and font",
        },
        logo: {
          title: "Add or Edit your Company Logo",
          description: `Click the button below to upload your Company logo. Images should be
          in <strong>'jpeg, jpg, png'</strong> format and not
          exceeding <strong>100 kB</strong> in size.`,
        },
        banner: {
          title: "Add or Edit your Banner Image",
          description: `Click the button below to upload your Company logo. Images should be
          in <strong>'jpeg, jpg, png'</strong> format and not
          exceeding <strong>1 MB</strong> in size.`,
        },
        privacyEmail: {
          title: "Add or Edit your Email",
          description: "Enter the privacy email address",
        },
      },
      success: "Theme successfully updated",
      error:
        "Could not fetch Privacy Center Theme at this time, please try again later.",
      dataError:
        "Could not fetch Privacy Center Theme properly, please contact support.",
    },
    websiteInstallation: {
      header: {
        feature: "Website Installation",
        heading: "How to install the Privacy Center on your website",
        description:
          "Please complete each step to ensure your Privacy Center goes live on your website.",
      },
      steps: {
        head: {
          title: "Insert script into the header tag of your Privacy Center",
          description:
            "Click the copy button to complete this step once you have copy and pasted the code",
        },
        body: {
          title: "Insert script into the body tag of your Privacy Center",
          description:
            "Click the copy button to complete this step once you have copy and pasted the code",
        },
        cookie: {
          title: "Insert Cookie script on all pages of the website",
          description:
            "Click the copy button to complete this step once you have copy and pasted the code",
        },
      },
      emailDeveloper: {
        description:
          "Please input the developer's email here and we will send instructions on how to get your Privacy Center live.",
        form: {
          input: {
            label: "Email",
            placeholder: "Enter the email here",
          },
          errors: {
            emailInvalid: "Please provide a valid email address.",
            emailRequired: "Email is a required field.",
          },
          button: {
            cta: "Send Email",
            cancel: "Cancel",
          },
          successMessage: "Email sent to the developer.",
        },
      },
      buttons: {
        email: "Send to Developer",
        help: "Contact Support",
      },
      error:
        "Could not fetch the scripts of your Privacy Center at this time, please try again later.",
      dataError:
        "Could not fetch privacy center snippet scripts properly, please contact support.",
    },
    preview: {
      header: {
        feature: "Live Preview",
        heading: "Privacy Center Preview",
        description:
          "This is a live preview of your privacy center on your website.",
      },
      error:
        "Could not fetch privacy url at this time, please try again later.",
    },
  },
  policies: {
    header: {
      feature: "Policies",
      heading: "View and manage your policies",
      description:
        "Here, you can view, edit, and create new policies to ensure you remain compliant with regulations, transparent, and trusted by your customers.",
    },
    languageSelector: {
      label: "Policy language",
    },
    table: {
      columns: {
        name: "Policy Name",
        lastModifiedBy: "Last Modified By",
        createdAt: "Created At",
        updatedAt: "Updated At",
        updatedBy: "Updated By",
        status: "Status",
        edit: "Edit",
      },
      rows: {
        enabled: "Enabled",
        disabled: "Disabled",
        edit: "Edit",
      },
    },
    delete: {
      submit: "Delete policy",
      success: "Successfully deleted your policy",
      confirm: "Are you sure you want to delete this policy?",
    },
    add: {
      title: "Create new policy",
      addPDFTitle: "Create a new PDF policy",
      addTextTitle: "Create a new text policy",
      description:
        "Customize and format your new policy before publishing it to your Privacy Center.",
      editorPlaceholder: "Add your policy here",
      success: "Successfully created your policy",
      submit: "Create Policy",
    },
    edit: {
      title: "Edit your policy",
      description:
        "Make changes to your existing policy and update it in your Privacy Center.",
      success: "Successfully updated your policy",
      submit: "Save Policy",
      pdfLinkLabel:
        "Clicking the following link will open your policy in a new tab",
    },
    common: {
      back: "Back",
      icon: { label: "Icon", required: "You must select an icon" },
      language: { label: "Language", required: "You must select a language" },
      name: {
        placeholder: "Title of Policy goes here",
        title: "Policy Name",
        required: "You must enter the name of your policy",
      },
      content: {
        required: "You must enter some policy content",
      },
      pdfUrl: {
        required: "You must attach a policy file to upload",
      },
      active: {
        warning: "If you disable this policy it will no longer be visible to your users",
        required: "You must enable or disable your policy",
        tooltip: "Check the box to set your policy to active",
        checkboxLabel: "Enabled",
      },
    },
  },
};
